module.exports = __webpack_public_path__ + "static/media/ServiceLandingSectionBg.52037f71.png";